<template>
  <div>
    <LLTabs2
      v-model="internalValue"
      class="notifications-panel-tabs"
      :items="tabs"
      small
      @change="onChange"
    />
  </div>
</template>

<script>
import LLTabs2 from '@/components/common/LLTabs2.vue'

export default {
  name: 'NotificationsPanelTabs',
  components: { LLTabs2 },
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: String, default: 'all' },
    meta: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  computed: {
    tabs() {
      return [
        {
          key: 'all',
          label: this.$t?.('notifications.tabs.all') || 'All',
          badge: this.meta.total ?? undefined
        },
        {
          key: 'unread',
          label: this.$t?.('notifications.tabs.unread') || 'Unread',
          badge: this.meta.unread ?? undefined
        }
      ]
    }
  },
  watch: {
    value(v) {
      this.internalValue = v
    },
    internalValue(v) {
      this.$emit('input', v)
    }
  },
  methods: {
    onChange(key) {
      this.$emit('change', key)
    }
  }
}
</script>
